/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { UserPositionsService } from '@control-tower/platform-core';
import { Observable, of } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFCoreEntities,
} from '@pf/shared-common';
import { UserPositionStore } from './user-position.store';
import {
    UserPositionCreate,
    UserPositionRead,
    UserPositionSearchParams,
} from '../../entities/user-position.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class UserPositionDataService extends AbstractDataService<
    UserPositionRead,
    UserPositionCreate
> {
    protected EntityName = PFCoreEntities.UserPosition;
    constructor(
        private service: UserPositionsService,
        store: UserPositionStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(
        body: UserPositionCreate
    ): Observable<UserPositionRead> {
        return this.service.userPositionCreate({
            userPositionViewModelCreateBody: body,
        }) as Observable<UserPositionRead>;
    }
    protected deleteObs$(id: string): Observable<UserPositionRead> {
        return this.service.userPositionDelete({
            id,
        }) as Observable<UserPositionRead>;
    }
    protected undoDeleteObs$(id: string): Observable<UserPositionRead> {
        return this.service.userPositionUndoDelete({
            id,
        }) as Observable<UserPositionRead>;
    }
    protected getObs$(id: string): Observable<UserPositionRead> {
        return this.service.userPositionReadById({
            id,
        }) as Observable<UserPositionRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[]
    ): Observable<UserPositionRead> {
        return this.service.userPositionUpdatePatch({
            id,
            operation: operations,
        }) as Observable<UserPositionRead>;
    }
    protected searchObs$(
        searchParams: UserPositionSearchParams
    ): Observable<IPagedResult<UserPositionRead>> {
        return this.service.userPositionSearch(searchParams) as Observable<
            IPagedResult<UserPositionRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<IPagedResult<EntityChangeTrackingDto<UserPositionRead>>> {
        return this.service.userPositionGetChanges(searchParams) as Observable<
            IPagedResult<EntityChangeTrackingDto<UserPositionRead>>
        >;
    }
}
